export default "dist/images/e66b0c327f97d08e4253f52234d659eb.png";